import React from "react";
import {PublicApiCallToActionResponse} from "../Representation";

interface CallToActionProps {
    cta?: PublicApiCallToActionResponse | null
}

const CallToAction = ({cta}: CallToActionProps) => {

    if (cta && cta.enabled) {
        return (
            <>
                <p>{ cta.description }</p>
                <p><a className="btn btn-primary btn-cta" target="_blank" rel="noopener noreferrer" type="button" href={ cta.url }>{ cta.text }</a></p>
            </>
        )
    }

    return null;

}

export default CallToAction;
